export default "__VITE_ASSET__Db7Pn8Ms__"